var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_setup.componentItemIds, function (itemIds, componentId) {
      return _c(_setup.FormControlTagsUsageComponent, {
        key: componentId,
        attrs: {
          "component-id": Number(componentId),
          "item-ids": itemIds,
          "tag-id": _setup.tagId,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }